import { v5 as uuidv5 } from 'uuid'

const SIGNUP_MOTIVATIONS_NAMESPACE = '777ea880-450e-11f0-abff-325096b39f47'

export const SIGNUP_MOTIVATIONS = [
  'Try Exciting New Recipes',
  'Pack in More Veg',
  'Find Meals for Your Family',
  'Cook Lower Calorie Meals',
  'Save Time Cooking',
] as const

type MotivationLabel = typeof SIGNUP_MOTIVATIONS[number]

export const signupMotivationUUIDs: string[] = SIGNUP_MOTIVATIONS.map(
  (motivation: MotivationLabel) => uuidv5(motivation, SIGNUP_MOTIVATIONS_NAMESPACE),
)
